
import { number } from "echarts";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    tableData: [],
    columns: [],
    text_label: "",
  },
})
export default class Paging extends Vue {}
